import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { environment } from '../../../../environments/environment';
import { StorageToken } from '../../../shared/configs/storage-token.config';
import { AuthService } from '../../services/http/auth/auth.service';
import { MasqueradeService } from '../../services/masquerade/masquerade.service';
import { StorageService } from '../../services/storage/storage.service';

import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

@Injectable()
export class HttpHeaderInterceptor implements HttpInterceptor {
  constructor(
    private authService: AuthService,
    private masqueradeService: MasqueradeService,
    private storageService: StorageService
  ) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    let modifiedRequest = request.clone();

    const isApiUrl = request.url.startsWith(environment.apiBaseUrl);
    if (isApiUrl) {
      modifiedRequest = this.addHeaders(modifiedRequest);
    }

    return next.handle(modifiedRequest).pipe(
      tap(event => {
        if (isApiUrl && event instanceof HttpResponse && this.masqueradeService.isMasqueraded()) {
          this.masqueradeService.applyRefreshedTokens(event.headers);
        }
      })
    );
  }

  private addHeaders(request: HttpRequest<unknown>): HttpRequest<unknown> {
    let refreshToken;
    let masquerade = 'false';
    let headers: any = {};

    if (this.masqueradeService.isMasqueraded()) {
      refreshToken = this.storageService.getCookie(StorageToken.masRefreshToken);
      masquerade = 'true';
    }

    if (this.authService.isLoggedIn) {
      // Send the access token so the backend (APIKeyHeader "Authorization") can validate it.
      // Missing this header is what makes the backend return 403.
      headers = {
        ...headers,
        Authorization: `Bearer ${this.authService.accessToken}`,
      };

      if (this.masqueradeService.isMasqueraded()) {
        let masqScopes = this.storageService.getFromLocalStorage(StorageToken.masqueradePermissions) || '';

        headers = {
          ...headers,
          masquerade: `${masquerade}`,
          refreshToken: `${refreshToken}`,
          'Masq-Scopes': masqScopes,
        };
      }
    }

    return request.clone({
      setHeaders: headers,
      withCredentials: true,
    });
  }
}
